import Model, { attr } from '@ember-data/model';

/**
 * Slimmed visitor-profile resource (JSON:API type `blacklist-visitor-profiles`)
 * referenced by a blacklist-filter's `visitor-profile` relationship — the BE
 * returns this rather than the full `visitor-profiles` resource. Mock-first: the
 * real relationship isn't built yet; only Mirage serves it, behind the
 * `vis-profile-blocklist` flag.
 */
export default class BlacklistVisitorProfile extends Model {
  // Matched identifiers on the slimmed profile. Keys mirror envoy-web
  // `VisitorProfile#formatted_identifiers` exactly — note the BE emits
  // `identification-document-numbers`, not `identity-document-numbers`
  // (the matcher ATOM is `identity-document-number`; different concern).
  @attr({ defaultValue: () => null }) declare identifiers: {
    emails: string[];
    aliases: string[];
    'phone-numbers': string[];
    'identification-document-numbers': string[];
  } | null;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'blacklist-visitor-profile': BlacklistVisitorProfile;
  }
}
